import React, { useEffect } from "react";
import { TranslationContext } from "src/hooks";
import { PassportRoutes } from "src/modules/Passport.routes";
import { GoogleAnalyticsProvider } from "src/providers/GoogleAnalytics.provider";
import { browserEnvironment, fromEnv } from "src/helpers";
import { usePassportStore } from "src/stores/Passport.store";
import { CookieNames, getCookie, setCookie } from "src/helpers/cookies";
import { PASSPORT_ROUTES } from "src/constants/routes";
import { useHistory, useLocation } from "react-router-dom";
import { IEventParams } from "../interfaces/IEventParams";
import { MoengageProvider } from "../providers/MoengageAnalytics.provider";
import { OneKycCallbackScreen } from "./screens";

const PassportContainer = () => {
  const state = usePassportStore();
  const {
    authUser,
    selectedBusinessType,
    selectedPaymentMethod,
    outlet,
  } = state;
  const { push } = useHistory();
  const { pathname } = useLocation();

  useEffect(() => {
    const passportStep = getCookie(CookieNames.PassportStep);
    if (!passportStep) {
      setCookie(CookieNames.PassportStep, PASSPORT_ROUTES.entityType);
    }

    push(passportStep);
  }, [push]);

  let eventParameters: IEventParams = {
    browserEnv: browserEnvironment(),
    userID: authUser.id,
    merchantId: authUser.merchantId,
    email: authUser.email,
    fullName: authUser.fullName,
    timestamp: new Date().toISOString(),
    entityType: selectedBusinessType,
    packageSelected: selectedPaymentMethod,
    mcc: outlet.aspi?.mcc,
    pageName: pathname,
    passportStepName: getCookie(CookieNames.PassportStep),
    deploymentTag: fromEnv("REACT_APP_DOCKER_IMAGE_TAG"),
  };

  return (
    <TranslationContext.Provider
      value={
        state.isImprovementEnabled
          ? require("./translations.json")
          : require("./translations-legacy.json")
      }
    >
      <GoogleAnalyticsProvider
        trackPages
        category="Passport"
        eventParams={eventParameters}
        gaKey={fromEnv("REACT_APP_GA4_KEY")}
      >
        {fromEnv("REACT_APP_MOENGAGE_ENABLED") === "true" ? (
          <MoengageProvider
            category="Passport"
            moengageEnabled={fromEnv("REACT_APP_MOENGAGE_ENABLED")}
            eventParams={eventParameters}
          >
            <PassportRoutes />
          </MoengageProvider>
        ) : (
          <PassportRoutes />
        )}
      </GoogleAnalyticsProvider>
    </TranslationContext.Provider>
  );
};

const LivenessCallbackContainer = () => {
  const eventParameters: IEventParams = {
    browserEnv: browserEnvironment(),
    timestamp: new Date().toISOString(),
    deploymentTag: fromEnv("REACT_APP_DOCKER_IMAGE_TAG"),
  };

  return (
    <TranslationContext.Provider value={require("./translations.json")}>
      <GoogleAnalyticsProvider
        trackPages
        category="Passport"
        eventParams={eventParameters}
        gaKey={fromEnv("REACT_APP_GA4_KEY")}
      >
        {fromEnv("REACT_APP_MOENGAGE_ENABLED") === "true" ? (
          <MoengageProvider
            category="Passport"
            moengageEnabled={fromEnv("REACT_APP_MOENGAGE_ENABLED")}
            eventParams={eventParameters}
          >
            <OneKycCallbackScreen />
          </MoengageProvider>
        ) : (
          <OneKycCallbackScreen />
        )}
      </GoogleAnalyticsProvider>
    </TranslationContext.Provider>
  );
};

export { LivenessCallbackContainer };
export default PassportContainer;
